const Web3AuthContextKey = "web3auth_context";

export { Web3AuthContextKey };
